// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { eventHandler } = require('client-v2/common/utils/events')
const { InterestFollowCircleButton } = require('client-v2/common/components/buttons')
const { interestProfileHref } = require('client-v2/common/models/interest/actions')
const InterestsItemRecord = require('client-v2/common/models/interest/record')

// BEM Block entity definition
const bem = BemEntity('ArticleProfileInterestsItem')

function ArticleProfileInterestsItem(props) {
  const { interest } = props
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      ),
      dataset: {
        interestKey: interest.key
      }
    },
      tag('a', {
        className: bem.element('href'),
        href: interestProfileHref(interest),
        onClick: eventHandler(props.onInterestNavigate, { interest })
      },
        interest.name
      ),
      tag(InterestFollowCircleButton, {
        className: bem.element('button'),
        checked: interest.isFollowing,
        onClick: eventHandler(props.onInterestFollowClick, { interest })
      })
    )
  )
}

ArticleProfileInterestsItem.propTypes = {
  // Values
  className: PropTypes.string,
  interest: PropTypes.shape(InterestsItemRecord.propTypes).isRequired,
  // Callbacks
  onInterestFollowClick: PropTypes.func.isRequired,
  onInterestNavigate: PropTypes.func.isRequired
}

module.exports = ArticleProfileInterestsItem
